export default __webpack_public_path__ + "static/media3-d8714e40fb948f7d5e7749a19c47d7bc.jpg";